import React from 'react';
import Sidebar from '../../components/blog/sidebar';
import RelatedLinks from '../../components/blog/relatedlinks';
import { Container } from 'react-bootstrap';
import moment from 'moment';
import 'moment/locale/de';
import i18n from '../../components/i18n';
import { Col, Row, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
//import './blogcontent.scss';

/**
 * This content gets loaded on the url /language/blog
 * 
 * It contains the latest article, and a sidebar on the left for the last 5 posted articles.
 */
class BlogContent extends React.Component {
  render() {
    let lang = i18n.language.substring(0, 2);
    const { t } = this.props;

    return (
      <>
        <Container>

          <div>
            <div className="content-page-container mt-4">
              <div className="content-page">
                <Row>
                  <Col sm={{ order: 1 }}
                    md={{ order: 12 }}
                    lg={8}>

                    <div className="blog-date">{moment(this.props.frontmatter.date).locale(lang).format('LL')}</div>
                    
                    <div
                      className="blog-page-content"
                      dangerouslySetInnerHTML={{ __html: this.props.html }}
                    />


                    <RelatedLinks links={this.props.frontmatter.relatedlinks} />

<div style={{marginTop: "8rem", marginBottom: "8rem"}}>
    
    <div className="text-center">
      <div className="join-intro">{t('Blog.join_now')}</div>
      <Button href="https://app.nutrfy.com/signup" target="_blank" rel="noopener noreferrer" variant="primary" size="lg">
    {t('components.button_join')}</Button>
    </div>

    
  </div>


                  </Col>
                  <Col sm={{ order: 12 }}
                    md={{ order: 1 }}
                    lg={4}>
                    <Sidebar frontmatter={this.props.frontmatter} />
                  </Col>

                </Row>




              </div>
            </div></div>
        </Container>
      </>
    )
  }
}
export default withTranslation()(BlogContent);